import { ErrorPage } from 'app/src/shared/components'
import { useTranslation } from 'react-i18next'

export function JoinError() {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Error' })

  return (
    <ErrorPage errorMessage={t('text')}>
      <div className='mx-auto flex justify-center'></div>
    </ErrorPage>
  )
}
